
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podatek-od-nieruchomosci/druk-in-1",
      function () {
        return require("private-next-pages/podatek-od-nieruchomosci/druk-in-1/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podatek-od-nieruchomosci/druk-in-1"])
      });
    }
  